<!-- <div class="login-form">
    <p>
        {{ loginConfig.body.help_text }}
    </p>
    <div class="row">
        <div class="col-sm-12">
            <div class="c-form-group">
                <input
                    cclFormInput
                    type="text"
                    [(ngModel)]="loginModal.username"
                    class="c-c-form-group__input form-control"
                    placeholder="Username"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="c-form-group">
                <input
                    cclFormInput
                    type="password"
                    [(ngModel)]="loginModal.password"
                    class="c-c-form-group__input form-control"
                    placeholder="Password"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-8">
            If you haven’t registered, you can do so here.
        </div>
        <div class=" col-sm-4">
            <div class="c-form-group">
                <ccl-basic-button (clickEvent)="login()">Log In</ccl-basic-button>
            </div>
        </div>
    </div>
</div> -->

<div class="login-attendee-drawer" >
    <div class="row row--builder" [ngClass]="{'login-border' : isPopUp==false}" *ngIf="(loginConfig.body.isSSOEnabled && loginConfig.body.ssoConfigs.length>0) || (this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin'))">
        <div class="col col--builder">
            <div>
                <h3 [ngClass]="['header', 'login-header-background']">
                    <span [ngClass]="'login-header-label'">
                        {{ loginConfig.header.label }}
                    </span>
                    <span *ngIf="isPopUp" class="pull-right login-header-label" title="Close" (cclClick)="close()">
                        X
                    </span>
                </h3>
            </div>

            <div class="login-drawer-body">
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <div class="login-sso-buttons" *ngIf="loginConfig.body.isSSOEnabled && loginConfig.body.ssoConfigs.length>0">
                            <button
                                class="c-btn c-btn--primary"
                                [ngStyle]="{
                                    'background-color': loginConfig.footer.button.primary.background,
                                    color: loginConfig.footer.button.primary.color
                                }"
                                *ngFor="let ssoConfig of loginConfig.body.ssoConfigs"
                                [ngClass]="ssoConfig.ssoAccountConfig.buttonConfig.buttonClass"
                                (click)="loginWithSSO(ssoConfig.ssoAccountConfig.ssoConfig.id)"
                            >
                                <img
                                    role="presentation"
                                    src="{{ ssoConfig.ssoAccountConfig.buttonConfig.buttonIcon }}"
                                />
                                {{ ssoConfig.ssoAccountConfig.buttonConfig.buttonLabel }}
                            </button>

                            <form
                                id="ssoForm"
                                enctype="multipart/form-data"
                                method="post"
                                action=""
                                role="form"
                                class="form-inline"
                                encoding="multipart/form-data"
                            ></form>
                            <div class="c-form-group__hint">&nbsp;</div>
                        </div>
                        <div *ngIf="(this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin'))">
                        <div class="login-body-help">
                            <span [innerHTML]="loginConfig.body.help_text | safeHtml"></span>
                        </div>
                        <div class="login-body">
                            <div class="c-form-group">
                                <input
                                    aria-label="Username"
                                    cclFormInput
                                    id="username-label"
                                    type="text"
                                    role="textbox"
                                    class="c-c-form-group__input form-control"
                                    placeholder="{{ loginConfig.body.username }}"
                                    [(ngModel)]="loginModal.username"
                                />
                                <div class="c-form-group__hint">&nbsp;</div>
                            </div>
                            <div class="c-form-group">
                                <input
                                    aria-label="Password"
                                    cclFormInput
                                    type="password"
                                    role="textbox"
                                    id="password-label"
                                    class="c-c-form-group__input form-control"
                                    placeholder="{{ loginConfig.body.password }}"
                                    [(ngModel)]="loginModal.password"
                                    (keyup.enter)="login()"
                                />
                                <div class="c-form-group__hint">&nbsp;</div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="login-drawer-footer" *ngIf="(this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin'))">
                <div class="row row--builder">
                    <div class="col--builder col col-sm-7 col-xs-7">
                        <div class="login-footer-help">
                            <span [innerHTML]="loginConfig.footer.help_text | safeHtml"></span>
                        </div>
                    </div>
                    <div class="col--builder col col-sm-5 col-xs-5">
                        <div class="login-footer-button">
                            <button
                                [ngClass]="['c-btn', 'c-btn--secondary', 'login-footer-button-secondary']"
                                *ngIf="loginConfig.footer.formId != null"
                                (click)="openSignupForm()"
                            >
                                {{ loginConfig.footer.button.secondary.label }}
                            </button>
                            <button
                                [ngClass]="['c-btn', 'c-btn--primary', 'login-footer-button-primary']"
                                (click)="login()"
                            >
                                {{ loginConfig.footer.button.primary.label }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row row--builder" *ngIf="loginConfig.footer.isForgotPasswordEnabled">
                    <div class="col--builder col col-sm-7 col-xs-7">
                        <div class="login-footer-help">
                            <a href="javascript:void(0)" (click)="openPopup('forgotpassword')"> Forgot your password? </a>
                        </div>
                    </div>        
                </div>
            </div>
        </div>
    </div>
</div>
